import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import AppExtensionsSDK from "@pipedrive/app-extensions-sdk";

import { useDispatch } from "react-redux";

import Configurator from "../components/mappingWindow/Configurator";
import { setShowErrorModal } from "../store/slice/modalSlice";

import { useCmsHook } from "../helpers/cmsHook";

function MappingWindow() {
  const { cmsInstance } = useCmsHook();

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const initalizePipedriveSDK = async (id) => {
    try {
      await new AppExtensionsSDK({ identifier: id }).initialize({
        size: { width: 1200, height: 700 },
      });
    } catch (error) {
      console.log(error);
      let message;
      if (error.response && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
      dispatch(setShowErrorModal({ message: message }));
    }
  };

  useEffect(() => {
    const id = searchParams.get("id");
    if (id) {
      initalizePipedriveSDK(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mapping-window-bg-container">
      <Container className="mapping-window-container px-4">
        <Row>
          <Col>
            <div
              className={
                window.location.pathname === "/setup" ? "my-5" : "my-3"
              }
            >
              {cmsInstance &&
                cmsInstance.showRichText("cmsContent.mappingWindow")}
              <Configurator />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MappingWindow;
